//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: 'LoginModal',
  props: ['controller'],

  data() {
    return {
      issuer: null,
      active: true,
      knownIssuers: ["https://solidweb.org/", "https://broker.pod.inrupt.com/", "https://solidcommunity.net/"]
    };
  },

  methods: {
    login() {
      this.controller.login(this.issuer);
    }

  },

  mounted() {
    this.controller.once('ready', () => {
      this.active = false;
    });
  }

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('b-modal', {
    attrs: {
      "active": _vm.active,
      "has-modal-card": "",
      "can-cancel": false,
      "aria-role": "dialog",
      "aria-label": "Solid Login",
      "aria-modal": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function (e) {
        e.preventDefault();

        _vm.login();
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "100%",
      "min-width": "300px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Login to Solid Provider")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Solid Issuer"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "type": "url",
      "data": _vm.knownIssuers,
      "placeholder": "Your Solid Issuer",
      "clearable": "",
      "required": ""
    },
    on: {
      "select": function (option) {
        return _vm.selected = option;
      }
    },
    nativeOn: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.login();
      }
    },
    model: {
      value: _vm.issuer,
      callback: function ($$v) {
        _vm.issuer = $$v;
      },
      expression: "issuer"
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('b-button', {
    attrs: {
      "label": "Login",
      "type": "is-primary"
    },
    on: {
      "click": _vm.login
    }
  })], 1)])])]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-de2e46c8_0", {
    source: ".modal .animation-content .modal-card[data-v-de2e46c8]{overflow:visible!important}.modal-card-body[data-v-de2e46c8]{overflow:visible!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-de2e46c8";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var __vue_component__$3 = __vue_component__$2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'MenuComponent',
  props: ['controller', 'title'],

  data() {
    return {
      isLoggedIn: false,
      name: "",
      webId: "#"
    };
  },

  mounted() {
    this.controller.once('ready', () => {
      this.isLoggedIn = true;
      this.name = this.controller.name;
      this.webId = this.controller.getSession().info.webId;
    });
  },

  methods: {
    logout() {
      this.controller.logout();
      window.location = window.location;
    }

  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('b-navbar', {
    attrs: {
      "fixed-top": true,
      "type": "is-primary",
      "shadow": true
    },
    scopedSlots: _vm._u([{
      key: "brand",
      fn: function () {
        return [_c('b-navbar-item', [_c('h1', [_vm._v(_vm._s(_vm.title))])])];
      },
      proxy: true
    }, {
      key: "start",
      fn: function () {
        return [_c('b-navbar-item', {
          attrs: {
            "href": _vm.webId
          }
        }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('b-navbar-dropdown', {
          attrs: {
            "label": "Applications"
          }
        }, [_c('b-navbar-item', {
          attrs: {
            "href": "../consumer/"
          }
        }, [_vm._v("\n        Consumer application\n      ")]), _vm._v(" "), _c('b-navbar-item', {
          attrs: {
            "href": "../geolocationapi/"
          }
        }, [_vm._v("\n        Geolocation API\n      ")]), _vm._v(" "), _c('b-navbar-item', {
          attrs: {
            "href": "../qrscanner/"
          }
        }, [_vm._v("\n        QR-scanner\n      ")])], 1)];
      },
      proxy: true
    }, {
      key: "end",
      fn: function () {
        return [_c('b-navbar-item', {
          attrs: {
            "tag": "div"
          }
        }, [_c('div', {
          staticClass: "buttons"
        }, [_vm.isLoggedIn ? _c('a', {
          staticClass: "button is-light",
          on: {
            "click": _vm.logout
          }
        }, [_vm._v("\n                Log out\n            ")]) : _vm._e()])])];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var __vue_component__$1 = __vue_component__;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LoginModal: __vue_component__$3,
    MenuComponent: __vue_component__$1
});

// Import vue components

const install = function installIpin2022Components(Vue) {
  Object.entries(components).forEach(_ref => {
    let [componentName, component] = _ref;
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export { __vue_component__$3 as LoginModal, __vue_component__$1 as MenuComponent, install as default };
